module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"select":"Please select payment period","discountText":"The discount is applied only in the first month of payment of the tariff","discount":"You received a","discount2":"discount for the first tariff payment thanks to the referral link"}}')
  delete Component.options._Ctor
}
